var _ellipse, _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinSupplierPrimaryInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 44,
    viewBox: "0 0 32 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16,
    cy: 41,
    rx: 6,
    ry: 3,
    fill: "#002A5C",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 15.8384C32 29.0319 20.6455 38.5624 17.0668 41.2386C16.4286 41.7158 15.5714 41.7158 14.9332 41.2386C11.3545 38.5624 0 29.0319 0 15.8384C0 7.09109 7.16344 0 16 0C24.8366 0 32 7.09109 32 15.8384Z",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 15.8384C31 22.1424 28.2864 27.6158 25.0764 31.8812C21.8682 36.1442 18.2154 39.131 16.4679 40.4378C16.1849 40.6494 15.8151 40.6494 15.5321 40.4378C13.7846 39.131 10.1318 36.1442 6.9236 31.8812C3.71362 27.6158 1 22.1424 1 15.8384C1 7.65292 7.70613 1 16 1C24.2939 1 31 7.65292 31 15.8384Z",
    stroke: "black",
    strokeOpacity: 0.16,
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36467_4379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6666 12.6667H20.1666V9.33337H8.49992C7.58325 9.33337 6.83325 10.0834 6.83325 11V20.1667H8.49992C8.49992 21.55 9.61659 22.6667 10.9999 22.6667C12.3833 22.6667 13.4999 21.55 13.4999 20.1667H18.4999C18.4999 21.55 19.6166 22.6667 20.9999 22.6667C22.3833 22.6667 23.4999 21.55 23.4999 20.1667H25.1666V16L22.6666 12.6667ZM22.2499 13.9167L23.8832 16H20.1666V13.9167H22.2499ZM10.9999 21C10.5416 21 10.1666 20.625 10.1666 20.1667C10.1666 19.7084 10.5416 19.3334 10.9999 19.3334C11.4583 19.3334 11.8333 19.7084 11.8333 20.1667C11.8333 20.625 11.4583 21 10.9999 21ZM12.8499 18.5C12.3916 17.9917 11.7416 17.6667 10.9999 17.6667C10.2583 17.6667 9.60825 17.9917 9.14992 18.5H8.49992V11H18.4999V18.5H12.8499ZM20.9999 21C20.5416 21 20.1666 20.625 20.1666 20.1667C20.1666 19.7084 20.5416 19.3334 20.9999 19.3334C21.4583 19.3334 21.8333 19.7084 21.8333 20.1667C21.8333 20.625 21.4583 21 20.9999 21Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36467_4379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinSupplierPrimaryInactive);
export default __webpack_public_path__ + "static/media/pinSupplierPrimaryInactive.9e5c504b.svg";
export { ForwardRef as ReactComponent };